module.exports = __webpack_public_path__ + "3198faa8ac345c64a7e17bdac19b01b0.svg";